import { CampaignModel, Contact, Group, mapToMediaModel, MediaModel } from ".";
import { UtilityService } from "../../services/UtilityService";

export class ScheduledMessageModel {
    constructor() { }

    ID: string;
    Type: ScheduleMessageType;
    PhoneNumberID: string;
    Names: string[];
    Message: string;
    Status: ScheduleMessageStatus;
    IsDeleted: boolean;
    CreatedDateTime: string;
    NextScheduledDateTime: string;
    LastSentDateTime: string;
    Groups: Group[];
    Contacts: Contact[];
    PhoneNumbers: string[];
    CronExpression: string;
    Media?: MediaModel[];
    Campaign?: CampaignModel | null;
    ContactIds?: string[]
    EndScheduledDateTime?: string;
}

export const mapToScheduledMessage = (x: any, contacts: Contact[], groups: Group[]) => {
    let groupsAdded = groups.filter(g => x.groups.includes(g.ID));
    return {
        ID: x.id,
        Type: x.scheduleType as ScheduleMessageType,
        PhoneNumberID: x.phoneNumberId,
        PhoneNumbers: x.numbers.map(x => UtilityService.unmaskPhoneNumber(x)),
        Message: x.body,
        Status: x.status as ScheduleMessageStatus,
        IsDeleted: x.isDeleted,
        CreatedDateTime: x.createdDateTime,
        LastSentDateTime: x.lastSent,
        NextScheduledDateTime: x.nextScheduled,

        Groups: groupsAdded.length ? groupsAdded : x.groups.map((x: string) => { return { ID: x } as Group }),
        CronExpression: x.cronExpression,
        Media: x.media ? x?.media.map(mapToMediaModel) : undefined,
        Campaign: x?.campaign ? { ID: x.campaign.id, ToPhoneNumbers: x.campaign.toPhoneNumbers, Name: x.campaign.name, CreatedDateTime: x.campaign.createdDateTime, CreatedById: x.campaign.createdById } as CampaignModel : null,
        ContactIds: x?.contacts,
        EndScheduledDateTime: x.endDateTime,
    } as ScheduledMessageModel;
}

export enum ScheduleMessageType {
    ONE_TIME = 0,
    DAILY,
    WEEKLY,
    MONTHLY,
    EVERY_6_MONTHS,
    EVERY_YEAR,
    EVERY_2_WEEKS
}
export enum ScheduleMessageStatus {
    NONE = 0,
    SCHEDULED,
    SENT,
    STOPPED,
}

export enum SecureScheduleMessageStatus {
    SCHEDULED = 1,
    STOPPED,
    DELETED,
    SENT
}

export enum ScheduleEmailType {
    WEEKLY = 0,
    MONTHLY
}

export class BulkImportReport {
    constructor() {
    }
    Id: string;
    IsDeleted: boolean;
    CreatedDateTime: string;
    CreatedById: string;
    CreatedBy: string;
    Source: string;
    FileName: string;
    SavedRecords: ScheduleRecord[]
    IgnoredRecords: ScheduleRecord[]
    ExistingRecords?: ScheduleRecord[]
}

export class ScheduleRecord {
    constructor() { }
    ContactNumber: string;
    Message: string;
    Type: string;
    ScheduleDateTime: string;
    Errors: any
}

export class ImportReportResponse {
    constructor() {
    }
    Id: string;
    IsDeleted: boolean;
    CreatedDateTime: string;
    CreatedById: string;
    CreatedBy: string;
    Source: string;
    FileName: string;
    SavedRecords: number;
    ExistingRecords: number;
    IgnoredRecords: number;
    Status: string;
    ClioHubspotAddedRecords?: number;
}

export const maptoImportReportResponse = (x: any): ImportReportResponse => {
    return {
        Id: x.id,
        IsDeleted: x.isDeleted,
        CreatedDateTime: x.createdDateTime,
        CreatedById: x.createdById,
        CreatedBy: x.createdBy,
        Source: x.source,
        FileName: x.fileName,
        SavedRecords: x.savedRecords,
        ExistingRecords: x?.existingRecords ?? 0,
        IgnoredRecords: x.ignoredRecords,
        Status: x.status,
        ClioHubspotAddedRecords: x?.clioHubspotAddedRecords ?? 0
    } as ImportReportResponse;
}

export const MapToScheduleRecord = (x) => {
    return {
        ContactNumber: x.contactNumber,
        Message: x.message,
        Type: x.type,
        ScheduleDateTime: x.scheduledDateTime,
        Errors: x.errors
    }
}

export const MaptoBulkImportReport = (x: any): BulkImportReport => {
    return {
        Id: x.id,
        IsDeleted: x.isDeleted,
        CreatedDateTime: x.createdDateTime,
        CreatedById: x.createdById,
        CreatedBy: x.createdBy,
        Source: x.source,
        FileName: x.fileName,
        SavedRecords: x.savedRecords.map(MapToScheduleRecord),
        IgnoredRecords: x.ignoredRecords.map(MapToScheduleRecord)
    } as BulkImportReport;
}

export enum SecureScheduleMessageType {
    ONE_TIME = 1,
    DAILY,
    WEEKLY,
    MONTHLY
}